import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { initials } from "../../lib/fmt";
const SIZE_PX = { sm: 24, md: 32, lg: 40 };
export function Avatar({ name, size = "md", className }) {
    const px = SIZE_PX[size];
    return (_jsx("span", { className: clsx("mono", className), style: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: px,
            height: px,
            borderRadius: 999,
            background: "var(--surface-2)",
            border: "1px solid var(--border)",
            color: "var(--ink-2)",
            fontSize: size === "sm" ? 10 : size === "lg" ? 14 : 12,
            fontWeight: 600,
            flexShrink: 0,
        }, "aria-label": name, children: initials(name) }));
}
//# sourceMappingURL=Avatar.js.map